//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import VueResource from 'vue-resource'
import store from '@/store'
import { mapState, mapActions } from 'vuex'
import { isService } from '../../common/js/util'
import BScroll from 'better-scroll'
import userEvaluate from './userEvaluate'
import progressQuery from './progressQuery'
import homeLogin from './homeLogin'
import helpRecord from './helpRecord'
import Titles from '@/components/titles'
import VeTRecom from './vetRecommend'
import QueryMode from './queryMode'
import Seo from './seo'
import Banner from './banner'

export default {
    components: {
        // BuyPopUp,
        userEvaluate,
        // progressQuery,
        helpRecord,
        homeLogin,
        Titles,
        VeTRecom,
        QueryMode,
        Seo,
        Banner
    },
    data() {
        return {
            isShowPestDialog: false,
            noLogin: false, // 用户登陆成功
            isShowQrcode: false, // 隐藏关注二维码
            page: 0,
            currentAppointmentInfo: null,
            buttonMessage: '开通会员',
            queryId: null,
            queryType: null,
            scroll: null,
            singalAppointmentId: 26,
            singalAppointmentCount: 0,
            isShow: false,
            isShowInfoDialog: false,
            // 是否显示会员购买弹窗
            // isShowBuyPopUp: false,
            // 会员弹窗的标题
            title: '',
            // 传入的会员等级 对应显示购买的列表
            vipStatus: '',
            //  设置购买列表默认显示哪一行
            iconSelect: null,
            vipinfo_return_page: '',
            tempVipPrice: '99', //单次一对一的价格
            queryItemList: false, // 留言容器
            startX: '',
            moveX: '',
            disX: 0,
            left: 0,
            haveAppointment: false,
            freeTipShow: false,
            unVipHaveQueryChance: false,
            noWeixin: false,
            isIOSApp: false,
            offlineNotification: false,
            isLogin: false //默认用户未登录
        }
    },
    computed: {
        ...mapState([
            'ownerView',
            'userProfile',
            'session',
            'completeInformation',
            'userIdentity',
            'noActivity',
            'isMobile'
        ]),
        isVipInfo() {
            return this.userIdentity == 'vip' || this.userIdentity == 'sVip' ? true : false
        }
    },
    created() {
        // let now =  Date.parse(new Date()),
        //     activityEndTime = new Date('2020/09/14 23:59').getTime()
        // if(activityEndTime-now>0){
        //     this.showWeiShiAcitvity = true
        // }else{
        //     this.showWeiShiAcitvity = false
        // }

    },
    // beforeRouteEnter(to, from, next){
    //     if(to.name==="home"&&navigator.userAgent.indexOf('MengZhua')>-1){
    //         // location.href="https://m.wecarepet.com/pages/article/cat/0"
    //         next("/mobile")
            
    //     }else{
    //         next()
    //     }
    // },
    mounted() {
 
        this.$nextTick(() => {
            if (!this.scroll) {
                this.scroll = new BScroll(this.$refs.homeWrapper, {
                    click: true
                })
            } else {
                this.scroll.refresh()
            }
        })
        // =======小程序下线===========
        let offlineNotificationTime = new Date('2020/04/03 10:00').getTime(),
            now = new Date().getTime()
        if (offlineNotificationTime - now > 0) {
            this.offlineNotification = false
        } else {
            this.offlineNotification = true
        }
        // ===================================================
        // 用户来源
        if (this.$route.query.source) {
            if (this.ownerView) {
                this.setSource(this.$route.query.source)
            } else {
                GLOBAL.setCookie('LoginSource', this.$route.query.source, 1)
            }
        }
        // 微信环境判断
        var ua = navigator.userAgent.toLowerCase()
        if (ua.indexOf('micromessenger') > -1) {
            this.noWeixin = false
        } else {
            this.noWeixin = true
        }
        
        let LoginStatus = GLOBAL.getInfo('LoginStatus')
        console.log(typeof(LoginStatus))
        if(typeof(LoginStatus) == undefined){
            store.dispatch('getLoginStatus')
        }else if(LoginStatus == 'false'){
            GLOBAL.sign(0, 'homePage','homePage')
            this.noLogin = true
        }else{
            if(!this.ownerView || !this.userProfile){
                store.dispatch('getLoginStatus').then((res)=>{
                    store.dispatch('getProfile').then((res)=>{
                        this.init()
                    })
                })
            }else{
                this.init()
            }
        }
    },
    methods: {
        ...mapActions(['findVIPUserInfo']),
        init(){
            this.noLogin = false
            this.$refs.queryMode.visitedQuery(this.ownerView.id)
            isService()
            if (GLOBAL.getCookie('LoginSource')) {
                var LoginSource = GLOBAL.getCookie('LoginSource')
                this.setSource(LoginSource)
            }
            GLOBAL.sign(this.ownerView.id, 'HomePage','homePage')
            this.getUserVipAndAppointment(this.ownerView.id)
            if(this.userIdentity != 'vip' && this.userIdentity != 'sVip'){
                this.hasFirstTimeFree()
            }
            // 用户信息是否完整
            if (this.completeInformation == null) {
                this.findVIPUserInfo()
            }
            this.getTempVipPrice()
            this.listActivations()
        },
        goVipGoodsDetail() {
            if (this.ownerView) {
                GLOBAL.sign(this.ownerView.id, 'VIPIntroduction-home','homePage')
            }
            this.$router.push({ path: '/vipGoodsDetail' })
        },
        // 查看非vip是否存在已购留言咨询机会
        listActivations() {
            this.$http
                .get(`${this.$store.state.origin}/api/query/v2/price/listActivations`)
                .then(res => {
                    if (res.body.status.error === 0) {
                        let result = res.body.result
                        this.singalAppointmentCount = result[this.singalAppointmentId]
                            ? result[this.singalAppointmentId].length
                            : 0
                        if (result[1] || result[2] || result[3])
                            this.unVipHaveQueryChance = true
                        else{
                            this.unVipHaveQueryChance = false
                        } 
                    } else {
                        GLOBAL.Alert(res.body.status.message)
                    }
                })
        },
        dialogStatus(val) {
            // 响应 疫情 弹窗Boolean
            this.isShowPestDialog = val
        },
        goPestIntro() {
            this.$router.push({ path: '/pest' })
        },
        goPestList() {
            this.$router.push({ path: '/pestQueryList' })
        },
        hasFirstTimeFree() {
            //检测用户是否有免费优惠券
            Vue.http
                .get(`${store.state.origin}/api/coupon/hasFirstTimeFree`)
                .then(res => {
                    this.freeTipShow = res.body.result
                    this.$nextTick(() => {
                        let left = 189 / 2 - this.$refs.singleButton.clientWidth / 2
                        this.$refs.freeTip.style.left = -left + 'px'
                    })
                })
        },

        isfollow() {
            this.$store.state.session.isShowServiceMain = false
            this.isShowQrcode = true
        },
        isExit() {
            this.$store.state.session.isShowServiceMain = false
            this.isShowQrcode = false
            GLOBAL.setInfo(
                'ExpiryDate',
                Date.parse(new Date()) + 24 * 60 * 60 * 1000 * 3
            )
        },
        dialogBtn() {},
        // 获取单次一对一价格
        getTempVipPrice() {
            this.$http
                .get(`${this.$store.state.origin}/pay/price/get?priceId=26`)
                .then(res => {
                    if (res.body.status.error === 0) {
                        this.tempVipPrice = res.body.result.value
                    }
                })
            // 调用此方法说明用户已经登陆 修改登录状态
            this.isLogin = true
        },
        setSource(source) {
            Vue.http
                .post(`${store.state.origin}/api/user/setSource?source=${source}`)
                .then(() => {
                })
                .catch(err => {})
        },
        randomNum() {
            var str = '0123456789'
            var num = new Date().getTime()
            for (var i = 0; i < 5; i++) {
                num += str.charAt(Math.floor(Math.random() * str.length))
            }
            return +num
        },
        closeDialog() {
            this.isShowInfoDialog = false
            GLOBAL.sign(this.ownerView.id, 'GiveUpInfo','homePage')
        },
        dialogInfoBtnEvent() {
            this.isShowInfoDialog = false
            this.$router.push({
                path: `/vipInfo/detail`,
                query: { returnPage: this.vipinfo_return_page }
            })
            GLOBAL.sign(this.ownerView.id, 'ToCompleteInfo','homePage')
        },
        goQueryTypeSelection() {
            if (this.ownerView) {
                GLOBAL.sign(this.ownerView.id, 'StartQuery','homePage')
            }
            this.$router.push({ path: '/query/queryType' })
        },
        toAppointment() {
            if ( (this.userIdentity == 'sVip' || this.singalAppointmentCount > 0) && !this.currentAppointmentInfo) {
                if (this.completeInformation) {
                    this.$router.push({
                        path: `/offlineNotification`
                    })
                } else {
                    this.vipinfo_return_page = 'offlineNotification'
                    this.isShowInfoDialog = true
                }
            } else if (this.currentAppointmentInfo) {
                location.href =
                    '//m.wecarepet.com/serverNumber/jumpToMyAppointmentAndQueryPage'
            } else {
                if (this.ownerView) {
                    GLOBAL.sign(this.ownerView.id, 'VIPIntroduction-1v1','homePage')
                }
                this.$router.push({ path: `/vipGoodsDetail` })
            }
        },
        getUserVipAndAppointment(id) {
            this.$http
                .get(`${this.$store.state.origin}/api/weixinService/query/current`)
                .then(res => {
                    this.currentAppointmentInfo = res.body.result
                    if (
                        this.currentAppointmentInfo == null &&
                        (this.userIdentity == 'sVip' || this.singalAppointmentCount > 0)
                    ) {
                        this.buttonMessage = '马上预约'
                    } else if (this.currentAppointmentInfo) {
                        this.buttonMessage = '已有预约 查看详情'
                        this.haveAppointment = true
                    } else {
                        this.buttonMessage = '开通会员'
                    }
                })
        },
        // 购买单次服务号咨询
        buyTempVip() {
            if (location.href.indexOf('m.wecarepet') > 0) {
                location.href = `//m.wecarepet.com/serverNumber/buyServe?type=singleConsultation&redirectURL=${window.btoa(
                    `//m.wecarepet.com/web/`
                )}`
            } 
        },
        // 开通会员 列表包括vip svip
        buyVip() {
            if (this.ownerView) {
                GLOBAL.sign(this.ownerView.id, 'VIPIntroduction-query','homePage')
            }
            this.$router.push({ path: `/vipGoodsDetail` })
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/home/index.vue